module.exports = __webpack_public_path__ + "static/bed2-d439db1d00643619e5575a84427dfad2.jpg";